import React, { useState } from 'react';
import ApplicationContainer from '../../../state/containers/ApplicationContainer';
import FeatureContainer from '../../../state/containers/FeatureContainer';
import ApplicationContentTree from './ApplicationContentTree';
import ApplicationVariablesList from './ApplicationVariablesList';
import ContentTreeStateContainer from '../../../state/containers/ContentTreeStateContainer';
import TabContainerPanel from '../../../components/structure/Panels/TabContainerPanel';
import { TabPanel } from 'react-tabs';
import AppliedApplicationTemplateContainer from '../../../state/containers/AppliedApplicationTemplateContainer';
import ApplicationBackupVersionsContainer from '../../../state/containers/ApplicationBackupVersionsContainer';
import ApplicationModel from '../../../models/applications/api/ApplicationModel';
import ApplicationVariablesContainer from '../../../hooks/ApplicationVariablesContainer';
const contentTreeIcon = require("../../../content/images/tab-icons/content-tree.svg");
const contentTreeBlueIcon = require("../../../content/images/tab-icons/content-tree-blue.svg");
const constantsIcon = require("../../../content/images/tab-icons/constants-dark.svg");
const constantsBlueIcon = require("../../../content/images/tab-icons/constants-blue.svg");

interface ApplicationContentMenuProps {
    application: ApplicationModel
    appContainer: ApplicationContainer
    featureContainer: FeatureContainer
    backupsContainer: ApplicationBackupVersionsContainer
    treeContainer: ContentTreeStateContainer
    history: any
}
const ApplicationContentMenuContent: React.FC<ApplicationContentMenuProps> = (props) => {
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);

    const handleTabChange = (index: number) => {
        setSelectedTabIndex(index);
    }

    return (
        <ApplicationVariablesContainer.Provider>
            <TabContainerPanel tabs={[{
                title: 'Explorer',
                icon: contentTreeIcon,
                selectedIcon: contentTreeBlueIcon
            }, {
                title: 'Constants',
                icon: constantsIcon,
                selectedIcon: constantsBlueIcon
            }
            ]} onTabSelected={handleTabChange} selectedIndex={selectedTabIndex}>
                <TabPanel>
                    <div className="expanded-content-tree-container">
                        <ApplicationContentTree history={props.history}
                            key={props.application?.id}
                            application={props.application}
                            appContainer={props.appContainer}
                            featureContainer={props.featureContainer}
                            backupsContainer={props.backupsContainer}
                            treeContainer={props.treeContainer} />
                    </div>
                </TabPanel>
                <TabPanel>
                    <div className="expanded-content-tree-container">
                        <ApplicationVariablesList 
                            application={props.application}
                        />
                    </div>
                </TabPanel>
            </TabContainerPanel>
        </ApplicationVariablesContainer.Provider>
    )
}

export default ApplicationContentMenuContent;